import TooltipCustom from 'ui/atoms/Tooltip/Tooltip';
import { useTranslate } from 'core/hooks/useTranslate';
import PropTypes from 'prop-types';
import React from 'react';
import { Icon } from 'ui';

const Tag = ({ text, color, tooltip, size, icon, iconColor, onClick, styleText, classTooltip, style, iconLeft, iconSize }) => {
  const { t } = useTranslate();

  // Check if text is a React element (JSX) or a string
  const isReactElement = React.isValidElement(text);

  function renderTag() {
    return (
      <div style={style} className={`tag tag--color-${color} tag--size-${size} ${onClick ? 'tag--clickable' : ''}`} {...(onClick ? { onClick } : {})}>
        {icon && iconLeft && (
          <div className="tag__icon">
            <Icon color={iconColor} name={icon} size={iconSize} />
          </div>
        )}
        <span className="tag__text" style={styleText}>
          {isReactElement ? text : t(`common:${text}`)}
        </span>
        {icon && !iconLeft && (
          <div className="tag__icon">
            <Icon color={iconColor} name={icon} size={iconSize} />
          </div>
        )}
      </div>
    );
  }

  return (
    <>
      {tooltip && (
        <TooltipCustom classes={{ tooltip: `tag-tooltip ${classTooltip}`, popper: 'tag-tooltip__popper' }} title={tooltip} placement="top">
          {renderTag()}
        </TooltipCustom>
      )}
      {!tooltip && renderTag()}
    </>
  );
};

Tag.propTypes = {
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  color: PropTypes.oneOf(['default', 'primary', 'success', 'blue', 'transparent']),
  size: PropTypes.oneOf(['default', 'big', 'medium']),
  iconColor: PropTypes.oneOf(['default']),
  onClick: PropTypes.func,
  iconLeft: PropTypes.bool,
  tooltip: PropTypes.node,
  classTooltip: PropTypes.string,
  style: PropTypes.object,
  styleText: PropTypes.object,
  iconSize: PropTypes.oneOf(['sm', 'm', 'lg', '3xl']),
};

Tag.defaultProps = {
  text: '',
  color: 'default',
  size: 'default',
  iconColor: 'default',
  iconLeft: false,
  tooltip: null,
  classTooltip: '',
  style: {},
  styleText: {},
};

export default Tag;
